import { DistrictResult } from '../district';
import { CustomerAddressType } from '../enums';
import { ProvinceResult } from '../province';

export class CustomerAddressResult {
    public id: number = 0;
    public districtId: number | null;
    public districtName: string = '';
    public provinceId: number | null;
    public provinceName: string = '';
    public countryId: number | null;
    public countryName: string = '';
    public postalCode: string;
    public description: string;
    public customerId: number | null = null;
    public customerName: string = '';
    public customerAddressType: CustomerAddressType;

    /////////////////////Front-End////////////////////
    public provinceList: Array<ProvinceResult>;
    public districtList: Array<DistrictResult>;

    public isDeleted: boolean;
    public districtIdIsInvalid: boolean;
    public postalCodeIsInvalid: boolean;
    public customerIdIsInvalid: boolean;
    public customerAddressTypeIsInvalid: boolean;

    constructor() {
        this.districtId = null;
        this.postalCode = '';
        this.description = '';
        this.customerAddressType = CustomerAddressType.BillingAddress;
        this.countryId = null;
        this.provinceId = null;
        this.districtIdIsInvalid = false;
        this.postalCodeIsInvalid = false;
        this.customerIdIsInvalid = false;
        this.customerAddressTypeIsInvalid = false;
        this.isDeleted = false;
        this.provinceList = new Array<ProvinceResult>();
        this.districtList = new Array<DistrictResult>();
    }
}
